module.exports = __webpack_public_path__ + "img/JOC_3289.81561110.jpg";